import { render, staticRenderFns } from "./depositSuccess.vue?vue&type=template&id=0c4944f9&"
import script from "./depositSuccess.vue?vue&type=script&lang=js&"
export * from "./depositSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports